import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { useInquiry } from "@/components/InquiryModal";

const ExistingSiteCta = () => {
  const { open } = useInquiry();
  return (
    <section
      data-testid="existing-site-cta-section"
      className="bg-cream-dark border-y border-taupe/10 py-16 md:py-20"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8">
            <div className="max-w-2xl">
              <h2
                data-testid="existing-site-cta-headline"
                className="font-serif font-medium tracking-tight text-charcoal text-2xl sm:text-3xl lg:text-4xl leading-tight"
              >
                Already Have a Website?{" "}
                <span className="italic text-turquoise">Let's Make It Better.</span>
              </h2>
              <p className="mt-4 font-sans text-base text-taupe leading-relaxed">
                Whether your website needs a fresh new look, better functionality, or a complete
                transformation, we're here to help.
              </p>
            </div>
            <button
              data-testid="existing-site-review-button"
              onClick={() => open("Redesign")}
              className="group shrink-0 inline-flex items-center justify-center gap-2 bg-turquoise text-charcoal hover:bg-turquoise-dark px-9 py-4 rounded-full font-sans font-semibold text-base shadow-[0_18px_36px_-12px_rgba(0,175,163,0.45)] transition-[background-color,transform,box-shadow] duration-300 hover:-translate-y-0.5"
            >
              Get a Website Review
              <ArrowRight size={18} className="transition-transform duration-300 group-hover:translate-x-1" />
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default ExistingSiteCta;
